import { twJoin } from 'tailwind-merge';

import { PhaserButton } from '../phaser-button';

import type { FC, PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
  colored?: boolean;
}>;

export const DialogBody: FC<Props> = ({ children, colored }) => {
  return (
    <div
      className={twJoin(
        colored ? 'bg-gray' : 'bg-white border-t border-t-surface-secondary-7',
        'h-full p-6 space-y-6 sm:space-y-8',
      )}
    >
      {children}
      <PhaserButton />
    </div>
  );
};
